/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Owner_CategoryInputs */

const vi_media_owner_category = /** @type {(inputs: Media_Owner_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục bán`)
};

/**

* @param {Media_Owner_CategoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_owner_category = /** @type {((inputs?: Media_Owner_CategoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Owner_CategoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_owner_category(inputs)
});